import React, { useState, useEffect, useCallback } from 'react';
import propTypes from 'prop-types';
import HolidaysList from './components/HolidaysList';
import { getOptions } from 'helpers/getOptions';
import $api from 'http/index';

const HolidaysTab = ({ openSnackbar, holidayDates, toggleHolidayModal, refreshHoliday }) => {
  const [holidaysState, updateHolidaysState] = useState([]);

  const getHolidays = useCallback(async () => {
    const queryParams = new URLSearchParams();
    queryParams.append('from', holidayDates[0].toISOString());
    queryParams.append('to', holidayDates[1].toISOString());
    queryParams.append('isIndividual', 'false');
    try {
      const res = await $api.get(
        `${process.env.REACT_APP_BASE_URL}/holidays?${queryParams}`,
        getOptions()
      );
      updateHolidaysState(res.data);
    } catch (e) {
      openSnackbar('error', e.reason);
    }
  }, [holidayDates]);

  useEffect(() => {
    getHolidays();
  }, [holidayDates, refreshHoliday]);

  return (
    <>
      <HolidaysList
        openSnackbar={openSnackbar}
        holidays={holidaysState}
        toggleHolidayModal={toggleHolidayModal}
        getHolidays={getHolidays}
      />
    </>
  );
};

HolidaysTab.propTypes = {
  openSnackbar: propTypes.func.isRequired,
  holidays: propTypes.array.isRequired,
  isDataLoading: propTypes.bool.isRequired,
  holidayDates: propTypes.array.isRequired,
  toggleHolidayModal: propTypes.func.isRequired,
};

export default HolidaysTab;
